import { render, staticRenderFns } from "./message_records.vue?vue&type=template&id=28f68e3b&scoped=true&"
import script from "./message_records.vue?vue&type=script&lang=js&"
export * from "./message_records.vue?vue&type=script&lang=js&"
import style0 from "./message_records.vue?vue&type=style&index=0&id=28f68e3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f68e3b",
  null
  
)

export default component.exports